import PropTypes from 'prop-types';
import { selectMenuBreadcrumbs } from 'common/components/beacon/store/selectors';
import { useSelector } from 'react-redux';
import Breadcrumbs from 'common/components/tree-layout/components/Breadcrumbs';

const MenuBreadcrumbs = ({ id }) => {
  const breadcrumbs = useSelector(state => selectMenuBreadcrumbs(state, id));

  return (
    <div>
      <Breadcrumbs
        breadcrumbs={breadcrumbs}
        maxLimit={3}
        render={menu => <span className="text-table-color fw-normal">{menu.title}</span>}
      />
    </div>
  );
};

MenuBreadcrumbs.propTypes = {
  id: PropTypes.number.isRequired // menu id
};

export default MenuBreadcrumbs;
